import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
@Component({
  selector: 'app-event-date-history-popup',
  templateUrl: './event-date-history-popup.component.html',
  styleUrl: './event-date-history-popup.component.css',
})


export class EventDateHistoryPopupComponent {
  constructor(
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private apiService: ApiService,
    private router: Router,
    private toastrService: ToastrService,
    public commonService: CommonService,
    private dialogRef: MatDialogRef<EventDateHistoryPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any 
  
  ) {}
  dataSource: any[] = [];
  totalRecords: number = 0;
EventId:any;


  pagination = {
    pageNumber: 1,
    pageSize: 10,
    searchTerm: '',
    sortColumn: 'CreatedOn',
    sortDirection: 'DESC',
    EventId: this.data.UniqueEventId
  };

  searchTimeout: any;

  ngOnInit() {
    
  console.log('Popup Data:', this.data);
   this.EventId = this.data.EventId
     this.loadData();
  }

  closeDialog() {
    this.dialogRef.close();
  }
  loadData() {
    this.apiService
      .getRequest(API_ENDPOINTS.MSSIDC.GETTOTALEVENTSDATELISTbYUNIQUEEVENTID, this.pagination)
      .subscribe({
        next: (res: any) => {
          if (res && (res.status || res.Status)) {
            this.dataSource = res.data || [];
            this.totalRecords = res.totalRecords || 0;

            console.log('Bind Data:', this.dataSource);
          } else {
            this.dataSource = [];
            this.totalRecords = 0;
          }
        },
        error: (err) => {
          console.error(err);
          this.dataSource = [];
          this.totalRecords = 0;
        },
      });
  }

  // 📄 Pagination
  onPageChange(event: any) {
    this.pagination.pageNumber = event.pageIndex + 1;
    this.pagination.pageSize = event.pageSize;
    this.loadData();
  }

  // 🔽 Sorting
  sort(column: string) {
    if (this.pagination.sortColumn === column) {
      this.pagination.sortDirection =
        this.pagination.sortDirection === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.pagination.sortColumn = column;
      this.pagination.sortDirection = 'ASC';
    }

    this.pagination.pageNumber = 1;
    this.loadData();
  }

  // 🔍 Search (Debounce)
  onSearchChange(value: string) {
    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      this.pagination.searchTerm = value;
      this.pagination.pageNumber = 1;
      this.loadData();
    }, 500);
  }

  onchangeDate() {
    this.router.navigate(['/Update-Event-Date']);
  }

  // 🔄 Reset

  downloadFile(row: any) {
    const link = document.createElement('a');
    link.href = row.FilePath;
    link.download = row.FileName || 'file';
    link.target = '_blank';
    link.click();
  }
}
